/* eslint-disable */

import '../scss/formstack.scss'

/**
 * Import Components
 */
import InitFormstack from './components/forms/formstack.js'

/**
 * Init - initalises all formstack classes
 */

console.log('Initialising')

class Init {
  constructor() {
    new InitFormstack()
  }
}
new Init()
